var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookFundoBranco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#780000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-307.648 -206.466)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M319.648,206.466a12,12,0,1,0,12,12A12,12,0,0,0,319.648,206.466Zm0,23.193a11.193,11.193,0,1,1,11.193-11.193A11.193,11.193,0,0,1,319.648,229.659Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M319.649,208.546a9.921,9.921,0,1,0,9.92,9.92A9.92,9.92,0,0,0,319.649,208.546Zm2.78,6.051h-1.345a.583.583,0,0,0-.535.481v1.371h1.878c-.076,1.052-.231,2.014-.231,2.014h-1.656v5.961h-2.47v-5.961h-1.2v-2.007h1.2v-1.64c0-.3-.061-2.308,2.53-2.308h1.829Z",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFundoBranco);
export default __webpack_public_path__ + "static/media/facebook_fundo_branco.7bb60fd1cd8278427461e19d1fb34bd2.svg";
export { ForwardRef as ReactComponent };